var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
var SystemParamService = /** @class */ (function () {
    function SystemParamService() {
    }
    /**
     * 系统参数带条件的查询
     */
    SystemParamService.prototype.getSystemParams = function (data, page) {
        return this.netService.send({
            server: managementService.systemParamController.getSystemParams,
            data: data,
            page: page,
        });
    };
    /**
     * 修改系统参数
     */
    SystemParamService.prototype.modifySystemParam = function (data) {
        return this.netService.send({
            server: managementService.systemParamController.modifySystemParam,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], SystemParamService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SystemParamService.prototype, "getSystemParams", null);
    __decorate([
        Debounce()
    ], SystemParamService.prototype, "modifySystemParam", null);
    return SystemParamService;
}());
export { SystemParamService };
